module.exports = __webpack_public_path__ + "static/logo-long-39d25d8d91aa865a675eff57e7ce27f3.png";